import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const messages = ['🚀 ¡Acaba de suceder! Javier de México acaba de descargar su guía IA al Rescate.', '👀 Tendencia actual: 18 personas están personalizando sus prompts en este momento.', '⚡ ¡Acceso instantáneo! Elena de Colombia compró el eBook hace 45 segundos.', "⭐ Review 5/5: 'Mis correos ahora se escriben solos. Increíble.' — Marcos P.", '⚠️ ¡Casi agotado! Solo quedan 7 licencias con el descuento del 60%.', '🌎 Desde Argentina: Sofía acaba de optimizar su agenda semanal con IA.', '✅ Verificado: Todos los prompts de esta guía han sido probados en GPT-4o.', '🔥 ¡Nueva descarga! Ricardo de España acaba de ahorrar 3 horas de su lunes.'];
export function PopupNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial show after 30 seconds
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
      // Hide after 6 seconds
      setTimeout(() => {
        setIsVisible(false);
        setCurrentIndex(prev => (prev + 1) % messages.length);
      }, 6000);
    }, 30000);
    // Then cycle every 36 seconds (30s delay + 6s visible)
    const intervalTimer = setInterval(() => {
      setIsVisible(true);
      // Hide after 6 seconds
      setTimeout(() => {
        setIsVisible(false);
        setCurrentIndex(prev => (prev + 1) % messages.length);
      }, 6000);
    }, 36000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <div className="fixed bottom-5 left-5 z-[9999] pointer-events-none" data-id="element-354">
      <AnimatePresence data-id="element-355">
        {isVisible && <motion.div initial={{
        opacity: 0,
        x: -100,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -50,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-[#111111]/95 backdrop-blur-md border border-[#D4AF37]/40 rounded-xl p-4 shadow-[0_8px_32px_rgba(212,175,55,0.15)] max-w-[320px] pointer-events-auto" data-id="element-356">
            <p className="text-[#E8E0D0] text-sm font-medium leading-snug" data-id="element-357">
              {messages[currentIndex]}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}